import axios from "axios";

const state = { texts: void 0 };

const mutations = {
  SET_TEXTS(state, texts) {
    state.texts = texts;
  }
};

const actions = {
  loadTexts({ commit, state }) {
    if (state.texts) {
      return Promise.resolve();
    }

    return axios
      .get("/api/texts/")
      .then(response => {
        const texts = (response.data || []).reduce(
          (reduced, textData) => ({
            ...reduced,
            [textData.key]: textData.content
          }),
          {}
        );

        commit("SET_TEXTS", texts);
      })
      .catch(ignore => commit("ADD_ERROR_MESSAGE", "TEXTS_NOT_LOADED"));
  }
};

export default { state, mutations, actions };
